// @flow
import React from 'react';
import strings from 'strings';
import type { MenuButtonItemsProps } from 'types/app';
import FPActionButton from 'UI/components/atoms/FPActionButton';
import FPButtonMenu from 'UI/components/molecules/FPButtonMenu';

const { actions } = strings.searchProjects.preview;

type SearchProjectsHeaderActionPropTypes = {
  shouldShowRestoreButton?: boolean,
  menuItems: Array<MenuButtonItemsProps>,
  onOpenRestoreInterface?: () => void
};

const SearchProjectsHeaderAction = ({
  shouldShowRestoreButton = false,
  menuItems,
  onOpenRestoreInterface = null
}: SearchProjectsHeaderActionPropTypes) =>
  shouldShowRestoreButton ? (
    <FPActionButton text={actions.archivedSearchProject.title} onClick={onOpenRestoreInterface} />
  ) : (
    <FPButtonMenu
      title={actions.moreOptions.title}
      isIconButton
      variant="outlinePrimary"
      menuItems={menuItems}
    />
  );

export default SearchProjectsHeaderAction;
